const de = {
  edit: 'Seite bearbeiten',
  renderCardPush: 'Karte erstellen',
  renderCardTitle: 'Karten Titel',
  renderCardCaption: 'Karten Beschreibung',
  renderCardDelete: 'Karte löschen',
}
export default de;